import { render, staticRenderFns } from "./historyVoyageInvoice.vue?vue&type=template&id=437027b1"
import script from "./historyVoyageInvoice.vue?vue&type=script&lang=js"
export * from "./historyVoyageInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports